import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import Card2 from "./Card2";

const TestimonialSlider = ({ review }) => {
  const [maxHeight, setMaxHeight] = useState(0);
  const cardRefs = useRef([]);

  const calculateMaxHeight = () => {
    if (!cardRefs.current.length) {
      // console.log("No card refs found");
      return;
    }
    const heights = cardRefs.current
      .filter(Boolean)
      .map((card) => {
        const h = card.offsetHeight;
        // console.log("Card height:", h);
        return h;
      });
    if (heights.length === 0) return;
    const tallest = Math.max(...heights);
    // console.log("Tallest card height:", tallest);
    setMaxHeight(tallest);
  };

  useEffect(() => {
    if (!review?.result) return;

    // Reset refs array length
    cardRefs.current = [];

    // Wait for images to load then measure
    let loadedCount = 0;
    const images = review.result.map((item) => {
      const img = new Image();
      img.src = item.photo_url;
      img.onload = () => {
        loadedCount++;
        if (loadedCount === review.result.length) {
          calculateMaxHeight();
        }
      };
      img.onerror = () => {
        loadedCount++;
        if (loadedCount === review.result.length) {
          calculateMaxHeight();
        }
      };
      return img;
    });

    // Fallback call if images cached
    setTimeout(() => {
      calculateMaxHeight();
    }, 1500);

    window.addEventListener("resize", calculateMaxHeight);
    return () => window.removeEventListener("resize", calculateMaxHeight);
  }, [review]);

  useEffect(() => {
    if (!cardRefs.current.length) return;

    const resizeObserver = new ResizeObserver(() => {
      calculateMaxHeight();
    });

    cardRefs.current.forEach((card) => {
      if (card) resizeObserver.observe(card);
    });

    return () => resizeObserver.disconnect();
  }, [cardRefs.current.length]);

  const styles = {
    container: {
      padding: "20px",
      margin: "25px 0",
      fontFamily: "'Roboto', sans-serif",
    },
    title: {
      textAlign: "center",
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "40px",
      marginTop: "-10px",
      color: "#000",
    },
    swiperSlide: {
      display: "flex",
      justifyContent: "center",
      alignItems: "stretch",
    },
    cardWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "stretch",
      minHeight: maxHeight || "auto",
      transition: "min-height 0.3s ease",
      boxSizing: "border-box",
      width: "100%",
      maxWidth: "300px",  // force max width to match Card2 maxWidth
      margin: "0 auto",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Customer Testimonials</h2>
      <Swiper
        modules={[Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop={true}
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 4 },
        }}
        autoHeight={false}
      >
        {review?.result?.map((testimonial, index) => (
          <SwiperSlide key={index} style={styles.swiperSlide}>
            <div
              ref={(el) => (cardRefs.current[index] = el)}
              style={styles.cardWrapper}
            >
              <Card2 data={testimonial} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TestimonialSlider;
